import React from 'react';
import styled from 'styled-components';
import _range from 'lodash/range';
import { makeStyles } from '@material-ui/core/styles';

import useTranslation from 'hooks/use-translation';

import { Select, Option } from 'components/core/select';

const useStyles = makeStyles(() => ({
  paper: {
    width: 85,
    marginTop: 12,
  },
  list: {
    '& li': {
      height: `35px`,
      minHeight: `0`,
    },
  },
}));

export default function QuantitySelect({ onChange, value, quantityRemaining }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <StyledSelect
      MenuProps={{ classes: { paper: classes.paper, list: classes.list } }}
      onChange={onChange}
      value={value}
      SelectDisplayProps={{
        'aria-label': t('common.quantity', 'Quantity'),
      }}
    >
      {_range(1, quantityRemaining + 1).map((num) => (
        <Option key={num} value={num}>
          {num}
        </Option>
      ))}
    </StyledSelect>
  );
}

const StyledSelect = styled(Select)`
  width: 100px;
  height: 53px;
  margin-right: 15px;
  border-radius: 32px !important;
  font-size: 18px;

  svg {
    right: 18px;
    margin-top: 8px;
  }

  & .MuiSelect-root {
    padding-right: 51px !important;
    border-radius: 32px !important;
  }

  & .MuiSelect-select:focus {
    background-color: inherit;
  }

  & .MuiOutlinedInput-input {
    font-size: 18px;
  }
`;
